<template>
  <ag-grid-vue
    style="width: 40vw; height: 60vh"
    class="ag-theme-material"
    rowHeight="45"
    :columnDefs="columnDefs"
    :rowData="rowData"
    :frameworkComponents="frameworkComponents"
    :context="context"
  >
  </ag-grid-vue>
</template>

<script>
  import 'ag-grid-enterprise'
  import { AgGridVue } from 'ag-grid-vue'
  import EditPermissions from '@/appComponents/permissions/components/EditPermissions'
  import { getRoles } from '@/api'

  export default {
    components: {
      AgGridVue,
      EditPermissions,
    },
    props: {},
    data() {
      return {
        columnDefs: null,
        rowData: null,
        gridApi: null,
        frameworkComponents: null,
        context: null,
      }
    },
    beforeMount() {
      this.columnDefs = [
        { headerName: 'Role', field: 'name', filter: 'agTextColumnFilter', sortable: true, flex: 1, resizable: true },
        {
          headerName: 'Permissions',
          field: 'value',
          cellRendererFramework: 'EditPermissions',
          colId: 'params',
          flex: 1,
          autoHeight: true,
        },
      ]

      this.frameworkComponents = {
        editPermissionsRenderer: EditPermissions,
      }
      this.context = { componentParent: this }
      this.updateRoles()
    },
    methods: {
      updateRoles() {
        getRoles().then(resp => {
          this.rowData = resp.data.sort((a, b) => (a.id > b.id ? 1 : -1))
        })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// PermissionsTable.vue?043a1907